/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import { muiStyles } from './styles';
import WalletUserMappingForm from './WalletUserMappingForm';

export default withStyles(muiStyles)(WalletUserMappingForm);